module.exports = __webpack_public_path__ + "img/osrs-gold-gateway.bd3d476b.svg";